import * as React from 'react';
import { EditTag } from './EditTag';
import styled from 'styled-components';
import { ITag } from '../../../data/types';
import { Badge } from '../../shared/Badge';
import { ListItem, ListItemCell } from '../../shared/List/ListItem';
import { Column } from '../../layout/Column';

interface IProps {
  label: string;
  description: string;
  tag: ITag;
  style: React.CSSProperties;
}

export const TagRow = ({
  label,
  description,
  tag,
  style = {},
}: IProps): React.ReactElement => {
  return (
    <ListItem style={{ height: '100px', ...style }}>
      <ListItemCell>
        <Column>
          <TagLabel>
            <span>{label}</span>
            <span>
              {tag?.active === false && (
                <Badge text='Disabled' style={{ marginLeft: '5px' }} />
              )}
            </span>
          </TagLabel>
          <TagDescription>{description ? description : null}</TagDescription>
        </Column>
      </ListItemCell>
      <ListItemCell>{tag.exclude_weight ? <b>True</b> : 'False'}</ListItemCell>
      <ListItemCell>
        <EditTag tag={tag} />
      </ListItemCell>
    </ListItem>
  );
};

const TagLabel = styled.div`
  font-weight: bold;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const TagDescription = styled.div`
  color: var(--color-secondary-text);
`;
